(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jm-refresh"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jm-hero-carousel')) {
customElements.define('jm-hero-carousel', class extends HTMLElement {
connectedCallback() {
if(this.ready) return;
this.ready=true; this.index=0;
this.slides=[...this.querySelectorAll('.jm-carousel-slide')];
this.dots=[...this.querySelectorAll('[data-slide]')];
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.addEventListener('click',e=>{
const b=e.target.closest('button'); if(!b)return;
this.show(b.hasAttribute('data-slide')?Number(b.dataset.slide):this.index+Number(b.dataset.step));
this.restart();
});
this.addEventListener('mouseenter',()=>clearInterval(this.timer));
this.addEventListener('mouseleave',()=>this.restart());
this.addEventListener('focusin',()=>clearInterval(this.timer));
this.addEventListener('focusout',()=>this.restart());
let x=0;
this.addEventListener('touchstart',e=>{x=e.changedTouches[0].clientX;},{passive:true});
this.addEventListener('touchend',e=>{const d=e.changedTouches[0].clientX-x;if(Math.abs(d)>50){this.show(this.index+(d<0?1:-1));this.restart();}},{passive:true});
this.restart();
}
show(n){this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===this.index)));}
restart(){clearInterval(this.timer);if(!this.paused)this.timer=setInterval(()=>{if(!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show(this.index+1);},Number(this.dataset.seconds)*1000);}
disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
